import { useNavigate } from '@tanstack/react-router';
import { Button } from '@/shared/ui/Button';
import { Content, Screen } from '@/shared/ui/Layout';
import { TopBar } from '@/shared/ui/TopBar';
import { useDocumentTitle } from '@/shared/lib/useDocumentTitle';

/**
 * Адрес, которого нет.
 *
 * В приложении на телефоне такого состояния не бывает вовсе — туда нельзя попасть иначе, чем по
 * кнопке. В браузере можно: опечатка в адресе, старая ссылка из письма, адрес экрана, которого
 * больше нет после выката. До этого экрана роутер на такой адрес не рисовал НИЧЕГО —
 * `defaultNotFoundComponent` не был задан, и человек оставался на пустой странице, где не за что
 * взяться.
 *
 * Два выхода, и оба настоящие: «Назад» — туда, откуда пришли, если история есть, и «На главную»
 * — всегда. Перезагрузку тут не предлагаем: она вернёт ту же самую пустоту, в отличие от
 * `RouteError`, где перезагрузка и есть лечение (см. `chunkReload`).
 */
export function NotFound() {
  const navigate = useNavigate();
  useDocumentTitle('Страница не найдена');

  return (
    <Screen>
      <TopBar title="Страница не найдена" />
      <Content width="narrow" centered>
        <div className="flex flex-col gap-4 text-center">
          <p className="text-ink-soft">
            Такой страницы нет. Возможно, ссылка устарела или в адресе опечатка.
          </p>
          <Button onClick={() => void navigate({ to: '/' })}>На главную</Button>
          {history.length > 1 && (
            <Button variant="ghost" onClick={() => history.back()}>
              Назад
            </Button>
          )}
        </div>
      </Content>
    </Screen>
  );
}
